import { render, staticRenderFns } from "./IconCopilot.vue?vue&type=template&id=4639d5e2"
import script from "./IconCopilot.vue?vue&type=script&lang=js"
export * from "./IconCopilot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports